import { AxiosPromise } from 'axios';
import { IType, IGetTypes, IGetConverts, IConvert } from '../models/evaluation.model';
import axios from 'axios';

const uri = '/mgmt/evaluation';

export const getAllTypes = (): AxiosPromise<IGetTypes> => {
  return axios.get(`${uri}/type/entire`);
}

export const getTypes = (): AxiosPromise<IGetTypes> => {
  return axios.get(`${uri}/type`);
}

export const createType = (data: IType): AxiosPromise => {
  return axios.post(`${uri}/type`, data);
};

export const updateType = (typeCode: number, data: IType): AxiosPromise => {
  return axios.put(`${uri}/type/${typeCode}`, data);
};

export const getConverts = (typeCode: number): AxiosPromise<IGetConverts> => {
  return axios.get(`${uri}/type/conversion/${typeCode}`);
}

export const createConvert = (typeCode: number, data: IConvert): AxiosPromise => {
  return axios.post(`${uri}/type/conversion/${typeCode}`, data);
};

export const updateConvert = (conversionCode: number, data: IConvert): AxiosPromise => {
  return axios.put(`${uri}/type/conversion/${conversionCode}`, data);
};
